import axios from 'axios';
import {
  RESET_ACTIVE_BOX_STATS,
  UPDATE_ACTIVE_BOX_STATS,
  SET_BOX_IS_LOADING,
} from '@/store/actions/boxes';

const state = () => ({
  activeBoxID: null,
  activeBoxStats: {},
  boxIsLoading: false,
});

/* eslint-disable no-shadow, arrow-body-style */
const getters = {
  getActiveBoxID: (state) => state.activeBoxID,
  getActiveBoxStats: (state) => state.activeBoxStats,
  getBoxIsLoading: (state) => state.boxIsLoading,
};
/* eslint-enable */

const actions = {
  /* eslint-disable no-unused-vars */
  REQUEST_BOX_STATS: ({ commit }, boxID) => {
    commit(RESET_ACTIVE_BOX_STATS);
    commit(SET_BOX_IS_LOADING, true);
    axios.get(`${window.api_url}api/box/${boxID}/stats`);
  },
  RESTART_BOX_PLAYER: ({ commit }, boxID) => {
    axios.get(`${window.api_url}api/box/${boxID}/player/restart`);
  },
  /* eslint-enable */
  UPDATE_ACTIVE_BOX_STATS: ({ commit }, payload) => {
    commit(UPDATE_ACTIVE_BOX_STATS, payload);
    commit(SET_BOX_IS_LOADING, false);
  },
};

/* eslint-disable no-shadow, arrow-body-style, no-param-reassign */
const mutations = {
  UPDATE_ACTIVE_BOX_STATS: (state, payload) => {
    state.activeBoxStats = payload;
  },
  SET_BOX_IS_LOADING: (state, isLoading) => {
    state.boxIsLoading = isLoading;
  },
  RESET_ACTIVE_BOX_STATS: (s) => {
    const initial = state();

    Object.keys(initial).forEach((key) => {
      s[key] = initial[key];
    });
  },
};
/* eslint-enable */

export default {
  state,
  getters,
  actions,
  mutations,
};
